import { noteHeartPixels } from "../../shared/notes.ts";

const FILLED = noteHeartPixels(true);
const EMPTY = noteHeartPixels(false);

/**
 * The pixel heart on a pinned note (docs/notes.md "Hearts", shared/notes.ts NOTE_HEART): 7x6 art
 * pixels drawn as crisp rects, `scale` CSS pixels each. Filled red, or the ink outline alone with the
 * paper through it. Decorative; the slip's name and the button's say what it means.
 */
export function NoteHeart({ filled, scale = 2, className }: { filled: boolean; scale?: number; className?: string }) {
  const pixels = filled ? FILLED : EMPTY;
  return (
    <svg class={className ?? "note-heart"} width={7 * scale} height={6 * scale} viewBox="0 0 7 6" shape-rendering="crispEdges" aria-hidden="true" focusable="false">
      {pixels.map((p) => (
        <rect key={`${p.x}-${p.y}`} x={p.x} y={p.y} width="1" height="1" fill={p.fill} />
      ))}
    </svg>
  );
}
